import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typography } from 'antd';

import useRestHeight from '../../effects/useRestHeight';
import { permissions } from '../../store/selectors/user';
import controlColumn from './ControlColumn';
import Table from '../commons/Table';

const { Text } = Typography;

const style = {
  totalContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 8,
  },
};

const ControlTable = ({
  data,
  isLoading,
  structure,
  onDetailsShow,
  onFormEdit,
  onFormClone,
  onChange,
  onLoad,
  containerStyle,
  permissions,
  total,
  sort,
}) => {
  const containerRef = useRef(null);
  const height = useRestHeight(containerRef);
  const columns = useMemo(
    () => [
      ...structure.filter(item => !item.isCollapsed),
      controlColumn({ onDetailsShow, onFormEdit, onFormClone, permissions }),
    ],
    [structure, onDetailsShow, onFormEdit, onFormClone, permissions],
  );

  return (
    <div style={containerStyle}>
      <div style={style.totalContainer}>
        <Text>{`${data.length}/${total}`}</Text>
      </div>
      <Table
        initialSort={sort}
        data={data}
        columns={columns}
        onScrollEnd={onLoad}
        onSort={onChange}
        isLoading={isLoading}
        height={height}
        containerRef={containerRef}
      />
    </div>
  );
};

ControlTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  structure: PropTypes.arrayOf(PropTypes.shape({})),
  containerStyle: PropTypes.shape({}),
  onDetailsShow: PropTypes.func.isRequired,
  onFormEdit: PropTypes.func.isRequired,
  onFormClone: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onLoad: PropTypes.func.isRequired,
  permissions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  total: PropTypes.number,
  sort: PropTypes.shape({}),
};

ControlTable.defaultProps = {
  data: [],
  structure: [],
  containerStyle: null,
  total: 0,
  sort: null,
};

const mapStateToProps = state => {
  return {
    permissions: permissions(state),
  };
};

export default connect(mapStateToProps)(ControlTable);
